module.exports = __webpack_public_path__ + "img/u19.2dd726fd.png";